/* Fiche produit AutoStock Pro
   - sélecteur de garantie : met à jour le prix affiché
   - à l'ajout au panier : le niveau de garantie part en propriété de ligne,
     et le produit d'extension (variant configuré) est ajouté dans le même appel. */
(function () {
  function money(cents, format) {
    function fmt(dec, thou, deci) {
      var n = (cents / 100).toFixed(dec);
      var p = n.split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return dec ? p[0] + deci + p[1] : p[0];
    }
    return (format || '{{amount}} €').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount_no_decimals': return fmt(0, ',', '');
        case 'amount_with_comma_separator': return fmt(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(0, '.', '');
        case 'amount_with_space_separator': return fmt(2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fmt(0, ' ', '');
        case 'amount_with_apostrophe_separator': return fmt(2, "'", '.');
        default: return fmt(2, ',', '.');
      }
    });
  }

  class AspProductForm extends HTMLElement {
    connectedCallback() {
      this.base = parseInt(this.dataset.basePrice, 10) || 0;
      this.format = this.dataset.moneyFormat || '{{amount}} €';
      this.form = this.querySelector('form[action*="/cart/add"]');
      this.priceEls = document.querySelectorAll('[data-total-price]');
      this.inputs = this.querySelectorAll('input[name="properties[Garantie]"]');
      var self = this;
      this.inputs.forEach(function (i) { i.addEventListener('change', function () { self.update(); }); });
      if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
      this.update();
    }

    selected() {
      var el = this.querySelector('input[name="properties[Garantie]"]:checked');
      if (!el) return { add: 0, variant: null, label: '' };
      return {
        add: parseInt(el.dataset.addPrice, 10) || 0,
        variant: el.dataset.addonVariant || null,
        label: el.value
      };
    }

    update() {
      var s = this.selected();
      var total = this.base + s.add;
      this.priceEls.forEach(function (el) { el.textContent = money(total, this.format); }, this);
      var cta = this.querySelector('[data-cta-price]');
      if (cta) cta.textContent = money(total, this.format);
    }

    async onSubmit(e) {
      var s = this.selected();
      if (!s.variant) return; // ajout Shopify standard, la propriété suffit
      e.preventDefault();
      var mainId = this.form.querySelector('[name="id"]').value;
      var body = {
        items: [
          { id: Number(mainId), quantity: 1, properties: { 'Garantie': s.label } },
          { id: Number(s.variant), quantity: 1, properties: { 'Pièce couverte': this.dataset.productTitle || '' } }
        ]
      };
      var btn = this.form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Ajout en cours…'; }
      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
        });
        if (!res.ok) throw new Error(await res.text());
        window.location.href = '/cart';
      } catch (err) {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label; }
        alert("L'ajout au panier a échoué. Réessayez ou appelez le +33 1 62 53 00 93.");
      }
    }
  }
  if (!customElements.get('asp-product-form')) customElements.define('asp-product-form', AspProductForm);

  // galerie
  class AspGallery extends HTMLElement {
    connectedCallback() {
      var main = this.querySelector('[data-gallery-main] img');
      this.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!main) return;
          main.src = btn.dataset.full;
          main.srcset = '';
          this.parentNode.querySelectorAll('[data-gallery-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
          btn.setAttribute('aria-current', 'true');
        });
      });
    }
  }
  if (!customElements.get('asp-gallery')) customElements.define('asp-gallery', AspGallery);

  // panneau de filtres mobile
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-facets-open]');
    var close = e.target.closest('[data-facets-close]');
    var panel = document.querySelector('.asp-facets');
    if (!panel) return;
    if (open) { panel.dataset.open = 'true'; document.body.style.overflow = 'hidden'; }
    if (close) { panel.dataset.open = 'false'; document.body.style.overflow = ''; }
  });
})();
